// extracted by mini-css-extract-plugin
module.exports = {"faq":"Faq_faq__903_9","faq-title":"Faq_faq-title___L81d"};